var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-circle-icon',_vm._g({},_vm.$listeners),[_c('IconsPlayIcon24px')],1)}
var staticRenderFns = []

export { render, staticRenderFns }